<template>
  <div class="bjy-live-room-page">
    <div v-if="liveStatus === 2" class="bjy-live-ended">
      <div class="bjy-live-ended__content">
        <div class="bjy-live-ended__title">{{ liveInfo.title }}</div>
        <div class="bjy-live-ended__time">{{ liveInfo.startTime }} ~ {{ liveInfo.endTime }}</div>
        <img class="bjy-live-ended__img" src="https://latest-live-cdn.baijiayun.com/m/asset/resources/error-tips_292aaa727a.svg" alt="课程已结束" />
        <div class="bjy-live-ended__tip">额.. 该课程已结束啦</div>
      </div>
    </div>
    <Room v-else-if="roomOptions" :room-options="roomOptions" @error="handleRoomError" />
    <div v-else class="bjy-live-room-page__status">正在获取直播信息...</div>
  </div>
</template>

<script>
import Vue from 'vue'
import Room from './Room.vue'
import Dialog from './components/common/Dialog/dialog.js'
import Toast from './components/common/Toast/toast.js'

Vue.use(Dialog)
Vue.use(Toast)

export default {
  name: 'BjyLiveRoomPage',
  components: {
    Room,
  },
  data() {
    return {
      roomOptions: null,
      loading: false,
      liveStatus: null,
      liveInfo: {
        title: '',
        startTime: '',
        endTime: '',
      },
    }
  },
  created() {
    this.fetchRoomOptions()
  },
  mounted() {
    this.injectBaseStyle()
  },
  beforeDestroy() {
    this.removeBaseStyle()
  },
  methods: {
    async fetchRoomOptions() {
      if (this.loading) {
        return
      }
      this.loading = true
      const courseId = this.$route.query.course_id || this.$route.query.courseId || this.$route.params.course_id
      const videoId = this.$route.query.video_id || this.$route.query.videoId || this.$route.params.video_id
      try {
        const response = await this.axios.post('/getBjyLiveRoom', {
          course_id: courseId,
          video_id: videoId,
        })
        const responseData = response && response.data ? response.data : null
        const payload = responseData && responseData.data ? responseData.data : responseData && responseData.result ? responseData.result : responseData
        if (!payload) {
          throw new Error('empty room options')
        }
        this.liveStatus = payload.live_status != null ? Number(payload.live_status) : null
        const startTimeFull = this.formatTime(payload.startTime || payload.start_time || payload.live_time || '')
        const endTimeShort = this.formatHm(payload.live_etime || payload.endTime || payload.end_time || '')
        this.liveInfo = {
          title: payload.live_title || payload.title || payload.course_name || payload.name || '',
          startTime: startTimeFull,
          endTime: endTimeShort,
        }
        if (this.liveStatus === 2) {
          this.loading = false
          return
        }
        this.roomOptions = this.normalizeRoomOptions(payload)
      } catch (error) {
        console.error('百家云直播参数获取失败', error)
        this.$message.error('直播信息获取失败')
      } finally {
        this.loading = false
      }
    },
    handleRoomError(message) {
      this.$message.error(message || '直播页面初始化失败')
    },
    formatTime(value) {
      if (!value) {
        return ''
      }
      const date = value instanceof Date ? value : new Date(value)
      if (isNaN(date.getTime())) {
        return value
      }
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      const h = String(date.getHours()).padStart(2, '0')
      const min = String(date.getMinutes()).padStart(2, '0')
      return `${y}-${m}-${d} ${h}:${min}`
    },
    formatHm(value) {
      if (!value) {
        return ''
      }
      const date = value instanceof Date ? value : new Date(value)
      if (isNaN(date.getTime())) {
        return value
      }
      const h = String(date.getHours()).padStart(2, '0')
      const min = String(date.getMinutes()).padStart(2, '0')
      return `${h}:${min}`
    },
    injectBaseStyle() {
      const styleId = 'bjy-live-base-style'
      if (document.getElementById(styleId)) {
        return
      }
      const link = document.createElement('link')
      link.id = styleId
      link.rel = 'stylesheet'
      link.href = (process.env.BASE_URL || '/') + 'bjy-live-base.css'
      document.head.appendChild(link)
    },
    removeBaseStyle() {
      const styleId = 'bjy-live-base-style'
      const link = document.getElementById(styleId)
      if (link) {
        link.remove()
      }
    },
    normalizeRoomOptions(payload) {
      return {
        env: payload.env || 'production',
        prefixName:
          payload.prefixName ||
          payload.prefix_name ||
          payload.privateDomainPrefix ||
          payload.private_domain_prefix ||
          'e83315042',
        room_id: payload.room_id,
        user_number: payload.user_number,
        user_name: payload.user_name,
        user_role: payload.user_role != null ? payload.user_role : 0,
        user_avatar: payload.user_avatar,
        group_id: payload.group_id || '',
        teacher_number: payload.teacher_number || payload.user_number,
        teacher_name: payload.teacher_name || '老师',
        teacher_role: payload.teacher_role != null ? payload.teacher_role : 1,
        teacher_avatar: payload.teacher_avatar || payload.user_avatar || '',
        sign: payload.sign,
        webrtc: payload.webrtc != null ? payload.webrtc : 1,
        live_thumb: payload.live_thumb || '',
        live_time: payload.live_time || '',
      }
    },
  },
}
</script>

<style scoped>
.bjy-live-room-page {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background: #fff;
}

.bjy-live-room-page__status {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  color: #666;
  font-size: 14px;
}

.bjy-live-ended {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  background-image: -webkit-radial-gradient(#fff, #f1fbff);
  background-image: radial-gradient(#fff, #f1fbff);
  text-align: center;

  .bjy-live-ended__content {
    padding: 20px;
  }

  .bjy-live-ended__title {
    font-size: 22px;
    font-weight: 500;
    color: #333;
    margin-bottom: 12px;
  }

  .bjy-live-ended__time {
    font-size: 14px;
    color: #666;
    margin-bottom: 40px;
  }

  .bjy-live-ended__img {
    display: block;
    width: 260px;
    max-width: 80%;
    margin: 0 auto 30px;
  }

  .bjy-live-ended__tip {
    font-size: 14px;
    color: #666;
  }
}
</style>
